import React from 'react';

const LeaveDialog = ({ isOpen, onConfirm, onCancel }) => {
    if (!isOpen) return null;

    return (
        <div className="dialog-overlay">
            <div className="dialog-box">

                <div className="dialog-box-title dialog-box-title-leave">Leave the meeting?</div>

                <div className="dialog-box-content">
                    You will exit the meeting, but it will continue for other people.
                </div>


                <div class="dialog-box-footer">
                    <button onClick={onCancel} aria-label="Cancel" class="dialog-box-button-cancel" type="button">Cancel</button>
                    <button onClick={onConfirm} aria-label="Leave Meeting" class="dialog-box-button-confirm" type="submit">Leave Meeting</button>
                </div>

            </div>
        </div>
    );
};

export default LeaveDialog;